import elementoVisivel from '../dom';

const FORM = '[data-tour="recursos-form-julgamento"]';
const DESFECHO = '[data-tour="recursos-form-julgamento-desfecho"]';
const FUNDAMENTACAO = '[data-tour="recursos-form-julgamento-fundamentacao"]';
const UPLOAD = '[data-tour="recursos-form-julgamento-upload"]';
const ENVIAR = '[data-tour="recursos-enviar-julgamento"]';

export default {
  id: 'recursos-form-julgamento',
  kind: 'tour',
  version: 1,
  label: 'Julgamento da autoridade',
  contexts: ['auction.recursos'],
  scopes: ['form-julgamento'],
  priority: 40,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.podeJulgar);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.formVisible) return false;
    if (ctx.podeJulgar === false) return false;
    return Boolean(elementoVisivel(FORM));
  },
  steps() {
    const steps = [
      {
        element: FORM,
        popover: {
          title: 'Julgamento da autoridade',
          description:
            'Como autoridade, use este formulário para julgar o recurso na janela de consideração/julgamento.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    if (elementoVisivel(DESFECHO)) {
      steps.push({
        element: DESFECHO,
        popover: {
          title: 'Desfecho',
          description: 'Escolha se o recurso é admissível ou inadmissível.',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(FUNDAMENTACAO)) {
      steps.push({
        element: FUNDAMENTACAO,
        popover: {
          title: 'Fundamentação do julgamento',
          description:
            'Registre a fundamentação do julgamento. Após o envio, a decisão é permanente.',
          side: 'top',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(UPLOAD)) {
      steps.push({
        element: UPLOAD,
        popover: {
          title: 'Anexos',
          description: 'Anexe documentos que sustentem o julgamento, se houver.',
          side: 'left',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(ENVIAR)) {
      steps.push({
        element: ENVIAR,
        popover: {
          title: 'Enviar Julgamento',
          description:
            'Confirme e envie o julgamento. Depois disso, não será possível editar ou excluir por aqui.',
          side: 'top',
          align: 'start',
        },
      });
    }

    return steps;
  },
};
